import React from 'react';
import SEO from '../components/common/SEO';
import Bio from '../components/about/Bio';
import Awards from '../components/about/Awards';
import PersonalProjects from '../components/about/PersonalProjects';

const About = () => {
  return (
    <>
      <SEO
        title="About - Ky Tracy"
        description="Learn about Kylie Tracy, award-winning photographer specializing in empowering portraits. Discover my journey, awards, and personal photography projects."
        url="/about"
      />
      <div>
        <Bio />
        <Awards />
        <PersonalProjects />
      </div>
    </>
  );
};

export default About;
